import { Handle, Position } from '@xyflow/react';

export function CompetencyNode({
  data,
  sourcePosition = Position.Right,
  targetPosition = Position.Left
}) {
  // Truncate long competency names
  const displayName = data.name.length > 60
    ? data.name.substring(0, 57) + '...'
    : data.name;

  return (
    <div className="flow-node flow-node-competency">
      <Handle
        type="target"
        position={targetPosition}
        className="flow-handle"
      />
      <div className="flow-node-content">
        <div className="flow-node-title" title={data.name}>
          {displayName}
        </div>
        <div className="flow-node-stats">
          {data.actionCount} actions
        </div>
      </div>
      <Handle
        type="source"
        position={sourcePosition}
        className="flow-handle"
      />
    </div>
  );
}
